import { useEffect, useState, } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import { toast } from "react-toastify";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};
const AddWorker = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [workerDrp, setWorkerDrpData] = useState([]);
  const [cityDrp, setCityDrpData] = useState([]);
  const [stateDrp, setStateDrpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
    country_id: "101",
    worker_category_id: "",
    city_id: null,
    state_id: null,
    address: "",
    phone_number: "",
    image: "",
    image_url: "",
  });

  const getWorkerCategory = () => {
    axios.post(API_URL.WORKER_CATEGORY_LIST, {}).then((res) => {
      setWorkerDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setWorkerDrpData(cd);
    });
  };


  const getState = () => {
    axios.post(API_URL.STATE_LIST, { country_id: 101 }).then((res) => {
      setStateDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setStateDrpData(cd);
    });
  };


  const getCityData = () => {
    axios
      .post(API_URL.CITY_LIST, { state_id: formValue.state_id })
      .then((res) => {
        setCityDrpData(res.data.data);
        let cd = res.data.data.map((caw) => {
          return {
            label: caw.name,
            value: caw.id,
          };
        });
        setCityDrpData(cd);
      });
  };



  const onSave = () => {
    if (formValue.name &&
      formValue.city_id &&
      formValue.phone_number &&
      formValue.address &&
      formValue.worker_category_id &&
      formValue.state_id
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.WORKER_UPDATE : API_URL.WORKER_SAVE;
      axios
        .post(pUrl, formValue)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            let message = id
              ? "Workers Updated Successfully."
              : "Workers Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/settings/workers");
          }
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.VEHICLE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          address: res.data.data.address ? res.data.data.address : "",
          city_id: res.data.data.city_id ? res.data.data.city_id : "",
          state_id: res.data.data.state_id ? res.data.data.state_id : "",
          phone_number: res.data.data.phone_number ? res.data.data.phone_number : "",
          image: null,
          worker_category_id: res.data.data.worker_category_id
            ? res.data.data.worker_category_id
            : "",
          image_url: res.data.data.image ? res.data.data.image : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    getWorkerCategory();
    getState();
  }, []);

  useEffect(() => {
    getCityData();
  }, [formValue.state_id]);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Workers</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/settings/workers"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Image<span className="required-star">*</span></label>
                          <div
                            className={isRequiredField("image") && "required-box"}
                          >
                            <Crop
                              imagePreview={imagePreview}
                              cropShape={"round"}
                              guid={""}
                              onChangeCropper={async ({
                                fileCropped,
                                fileCroppedBase64,
                              }) => {
                                setFormValue({
                                  ...formValue,
                                  image: fileCroppedBase64,
                                });
                                setImagePreview(fileCroppedBase64);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {id && (
                        <div className="col-md-12">
                          <label>Preview</label>
                          <div>
                            <a
                              href={formValue.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={formValue.image_url}
                                height={100}
                                width={100}
                                alt="product_image"
                              />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-4 col-md-4 col-sm-12">
                        <div className="form-group">
                          <label>
                            Workers <span className="required-star">*</span>
                          </label>
                          <Select
                            options={workerDrp || []}
                            value={(workerDrp || []).find((r) => r.value === formValue.worker_category_id)}
                            styles={
                              isRequiredField("worker_category_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, worker_category_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Name<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.name}
                            className={
                              isRequiredField("name")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                name: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Contact Number<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.phone_number}
                            className={
                              isRequiredField("phone_number")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                phone_number: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>
                            State<span className="required-star">*</span>
                          </label>
                          <Select
                            options={stateDrp || []}
                            value={(stateDrp || []).find((r) => r.value === formValue.state_id)}
                            styles={
                              isRequiredField("state_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, state_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>
                            City<span className="required-star">*</span>
                          </label>
                          <Select
                            options={cityDrp || []}
                            value={(cityDrp || []).find((r) => r.value === formValue.city_id)}
                            styles={
                              isRequiredField("city_id")
                                ? customRequireStyles
                                : customStyles
                            }
                            onChange={(e) => {
                              setFormValue({ ...formValue, city_id: e.value });
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label>Address<span className="required-star">*</span></label>
                          <input
                            type="text"
                            name="name"
                            value={formValue.address}
                            className={
                              isRequiredField("address")
                                ? "form-control required"
                                : "form-control"
                            }
                            id="name"
                            onChange={(event) => {
                              setFormValue({
                                ...formValue,
                                address: event.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddWorker;
